'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ms_MY = require('../../date-picker/locale/ms_MY');

var _ms_MY2 = _interopRequireDefault(_ms_MY);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ms_MY2['default'];